import React from 'react';

type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export const FolderIcon: React.FC<Props> = ({
  color = '#606C77',
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon">
      <g id="Folder">
        <path
          id="Vector"
          d="M11.1 4.79844H16.05C18.2868 4.79844 20.1 6.61168 20.1 8.84844M12.0924 5.91778L11.4576 5.02909C10.9508 4.31954 10.1325 3.89844 9.26053 3.89844H7.5C5.01472 3.89844 3 5.91316 3 8.39844V15.5984C3 18.0837 5.01472 20.0984 7.5 20.0984H16.5C18.9853 20.0984 21 18.0837 21 15.5984V11.5484C21 9.06316 18.9853 7.04844 16.5 7.04844H14.2895C13.4175 7.04844 12.5992 6.62733 12.0924 5.91778Z"
          stroke={color}
          strokeWidth="1.35"
        />
        <path
          id="Line"
          d="M12 16.0516H17.4"
          stroke={color}
          strokeWidth="1.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
